import { ResponsivePie } from '@nivo/pie';
import React, { useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import axios from 'axios';
import ReactDOMServer from 'react-dom/server';
import { AppNoInfo, AppRemixIcon } from '@/layout/AppComponents';
import { axiosPath } from '../../../../../routing/helpers/router';
import ErrorHandler from '../../../../components/error/ErrorHandler';
import SpinnerLoader from '../../../../../layout/components/helpers/SpinnerLoader';
import colors from '../../../../../constants/colors';
import Translator from '../../../../../layout/components/helpers/Translator';
import useIsMounted from '../../../../components/hooks/useIsMounted';

export default function GCLPieChartTemplate1({ module }) {
  const dispatch = useDispatch();
  const isMounted = useIsMounted();
  const [data, setData] = useState();

  const loadData = useCallback(
    async () =>
      axios
        .post(axiosPath("api_r_user_authUser_getModuleWidgetInfo"), {
          moduleBridgeHex: module?.hex,
          cardType: module.cover?.type,
        })
        .then((r) => {
          if (isMounted.current) {
            setData(r.data);
          }
        })
        .catch((e) => dispatch(ErrorHandler(e))),

    [module]
  );

  useEffect(() => {
    loadData();
  }, []);

  const margin = { top: 0, right: 0, bottom: 0, left: 0 };

  if (data === undefined) {
    return <AppNoInfo icon={<SpinnerLoader size={50} />} />;
  }

  if (data.length === 0) {
    return (
      <AppNoInfo
        icon={<AppRemixIcon icon="eye-off" color={colors.grey500} size={34} />}
        text={ReactDOMServer.renderToString(
          <Translator file="admin" name="general.no-elements" />
        )}
      />
    );
  }

  return (
    <ChartContainer>
      <ResponsivePie
        margin={margin}
        data={data}
        padAngle={1}
        innerRadius={0.4}
        cornerRadius={2}
        colors={(d) => d?.data?.color}
        enableArcLinkLabels={false}
        enableArcLabels={false}
      />
    </ChartContainer>
  );
}

const ChartContainer = styled.div`
  width: 190px;
  height: 180px;
`;
